export default "__VITE_ASSET__BtGdWIem__"